import { Box, Typography } from "@mui/material";
const TitleBar = (props) => {
  return (
    <>
      <Box data-html2canvas-ignore="true" sx={{ display: 'flex', alignItems: 'flex-end', p: props.compact ? 0 : '10px 0px', mt: props.compact ? 0 : 2 }} >
        <>{props.arrow}{props.icon}</>
        <Typography variant="h1" sx={{ m: props.compact ? 0 : undefined }}> {props.title}</Typography>
      </Box>
      {!props.noBorder && (
        <Box data-html2canvas-ignore="true" sx={{ height: 2, width: '100%', backgroundColor: 'primary.main', mb: 2 }}></Box>
      )}
    </>
  )
}

export default TitleBar;